/** Format an ISO date string for display, or an em dash when absent. */
export function formatDate(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  return new Date(value).toLocaleDateString();
}

/** Format an ISO timestamp for display, or an em dash when absent. */
export function formatDateTime(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  return new Date(value).toLocaleString();
}

/** Due dates are business calendar dates, not viewer-local timestamps. */
export function formatBusinessDate(value: string | null | undefined): string {
  const day = value?.slice(0, 10);
  if (day === undefined || !/^\d{4}-\d{2}-\d{2}$/.test(day)) return '—';
  const date = new Date(`${day}T00:00:00.000Z`);
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== day) return '—';
  return new Intl.DateTimeFormat('en-NG', {
    timeZone: 'UTC',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(date);
}

export function lagosToday(now: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Africa/Lagos',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);
  const part = (type: string): string => parts.find((item) => item.type === type)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}

export function approvedDateError(value: string, now: Date = new Date()): string | undefined {
  if (formatBusinessDate(value) === '—' || value.length !== 10)
    return 'Choose a valid first repayment date.';
  if (Number(value.slice(8, 10)) > 28)
    return 'Choose a calendar day from 1 to 28. Days 29–31 are not supported.';
  if (value < lagosToday(now)) return 'The first repayment date cannot be in the past.';
  return undefined;
}
